import React from "react";
import ReactECharts from "echarts-for-react";
import { FaGreaterThan } from "react-icons/fa6";

const LineChartCard = ({ data, months, name }) => {
  const option = {
    xAxis: {
      type: "category",
      data: months,
      splitline: {
        show: false,
      },

      label: {
        backgroundColor: "#8599D6",
      },
    },
    grid: {
      top: "25%",
      left: "10%",
      right: "10%",
      bottom: "20%",
    },

    yAxis: {
      type: "value",
      splitLine: {
        show: false,
      },
    },

    dataZoom: [
      {
        type: "slider",
        show: true,
        xAxisIndex: [0],
        start: 0,
        end: 100,
        height: 1,
        bottom: 25,
        handleStyle: {
          color: "#6c757d",
        },
        filterColor: "rgba(108,117,125,0.2)",
        borderColor: "#ced4da",
      },
    ],

    series: [
      {
        data: data,
        type: "line",
        smooth: true,
        color: "#8599D6",

        label: {
          show: true,
          position: "top",
          color: "black",
        },
      },
    ],
  };

  return (
    <div className="bg-white rounded-lg shadow p-2 w-full h-full relative">
      {/* <div className="mt-[-10px]"> */}
      <h2 className="flex items-center gap-2 justify-center text-md  text-red-900 text-red-780 font-semibold absolute top-[20px] left-0 right-[10px]">
        {name} Issues Trend | Cases <FaGreaterThan size={10} /> 18 hrs
      </h2>
      {/* </div> */}
      <div className="">
        <ReactECharts
          option={option}
          style={{ height: "369px", width: "100%" }}
        />
      </div>
    </div>
  );
};

export default LineChartCard;
